import SlidingPanelWeb from "@components/sliders/SlidingPanelWeb";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

interface WebSliderProps {
  isOpen: boolean;
  onClose: () => void;
  activeComponent: React.ReactNode;
  heading: string;
  showCurrentAccount?: boolean;
  hasBackButton?: boolean;
  endComponent?: React.ReactNode;
  widthDesktop?: string;
  showHeader?: boolean;
}

const WebSlider = ({
  isOpen,
  onClose,
  activeComponent,
  heading,
  showCurrentAccount = false,
  hasBackButton = false,
  endComponent,
  widthDesktop = "35%",
  showHeader = true,
}: WebSliderProps) => {
  const location = useLocation();
  const dynamicHeading = location.state?.heading || heading;

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }

    // Cleanup to ensure no-scroll is removed when the component unmounts
    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [isOpen]);

  return (
    <SlidingPanelWeb
      hasBackButton={hasBackButton}
      isOpen={isOpen}
      heading={dynamicHeading}
      onClose={onClose}
      showCurrentAccount={showCurrentAccount}
      endComponent={endComponent}
      widthDesktop={widthDesktop}
      showHeader={showHeader}>
      <div className="flex flex-col h-full overflow-y-auto">
        {activeComponent}
      </div>
    </SlidingPanelWeb>
  );
};

export default WebSlider;
